import type { Psychic } from 'src/__generated__/graphqlTypes';
import type { RatePerMinuetType, RightPsychic } from 'types/objectTypes';

export const getRatePerMinute = (psychic: RightPsychic, frame: Psychic): RatePerMinuetType => {
  if (psychic.customerPrice === psychic.basePrice) {
    return {
      discount: `${psychic.customerPrice}/${frame.ratePerMinute}`,
      price: `${psychic.basePrice}/${frame.ratePerMinute}`,
    };
  }

  return {
    discount: `${psychic.customerPrice}/${frame.ratePerMinute}`,
    price: psychic.basePrice,
  };
};

export const getPsychicSelectionIcon = (psychic: RightPsychic, frame: Psychic) => {
  if (psychic.isFavorite && frame.heartImage?.url) {
    return frame.heartImage.url;
  }

  if (psychic.isInCircle && frame.circleImage?.url) {
    return frame.circleImage.url;
  }

  return null;
};
